import { Injectable } from '@angular/core';

import { ILoginResponse } from 'src/app/shared/constants/account';

import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  getToken(): string {
    return localStorage.token;
  }

  saveToken(token: string) {
    localStorage.token = token;
  }

  destroyToken() {
    localStorage.removeItem('token');
  }

  getUserType(): string {
    return localStorage.type;
  }

  decodeToken(): ILoginResponse {
    const token = this.getToken();
    if (!token) {
      return;
    }
    return jwtDecode(this.getToken());
  }
}
